import * as types from '../actionTypes/systemParameter'

export function getSystemParameters(systemParameters) {
  return {
    type: types.GET_SYSTEM_PARAMETERS,
    systemParameters
  }
}

export function getFaqUrl(faqUrl) {
  return {
    type: types.GET_FAQ_URL,
    faqUrl
  }
}

export function getComplaintsUrl(complaintsUrl) {
  return {
    type: types.GET_COMPLAINTS_URL,
    complaintsUrl
  }
}

export function getHomePageText(homePageText) {
  return {
    type: types.GET_HOME_PAGE_TEXT,
    homePageText
  }
}

export function getAnnualReturnStartYear(annualReturnStartYear) {
  return {
    type: types.GET_ANNUAL_RETURN_START_YEAR,
    annualReturnStartYear
  }
}

export function getRegistrationText(registrationText) {
  return {
    type: types.GET_REGISTRATION_TEXT,
    registrationText
  }
}

export function getAnnualReturnPageText(annualReturnPageText) {
  return {
    type: types.GET_ANNUAL_RETURN_PAGE_TEXT,
    annualReturnPageText
  }
}

export function getDPCNotificationEmail(dpcNotificationEmail) {
  return {
    type: types.GET_DPC_NOTIFICATION_EMAIL,
    dpcNotificationEmail
  }
}


// WEBPACK FOOTER //
// ./src/actions/systemParameter.js